import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";

import { Cliente as ClienteSelector } from "../cliente";
import { DireccionSelector, DireccionSelectorElement } from "../direccion";
import { firstMap, contains, isObservable, toObservable } from "keautils";

import { NuevoClienteDocumentacionModal } from "app/features/componentes/nuevoclientedocumentacion/modal";
import { observeResource } from "kea-resource";
import { Observable, BehaviorSubject } from "rxjs";
interface State {
    idCliente?: number;
}
interface Props {
    value?: number | null;
    onChange: (x: number | undefined | null) => void;
    loading?: boolean;
    /**Filtro para los clientes */
    filtroCliente?: models.FiltroCliente;
    idSucursalUsuario?: number;
    /**Si se define se va a filtrar sólo esta dirección */
    idDireccionUsuario?: number;
    idCliente?: number;

    /**Si no tiene permiso de documentar cualquier origen Se deben de filtrar las direcciones */
    filtrarDireccionesPermiso?: boolean;
    seleccionAutomatica?: boolean;
    readonly?: boolean;
}
class DireccionClienteSelectorViewNoRx extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);

        this.state = {};
    }


    private idClienteDireccion = (state: State, props: Props) => props.value;
    private clienteDireccion = createSelectorRx(this.idClienteDireccion, id => {
        return id != null ? observeResource(resources.Cliente.GetDireccion, id) : Observable.from([id]);
    });
    private clienteFromValue = createSelectorRx(this.clienteDireccion, x => x && x.Cliente);
    private idClienteFromValue = createSelectorRx(this.clienteDireccion, x => x && x.IdCliente);
    private idClienteFromState = (state: State, props: Props) => state.idCliente;
    private idClienteFromProps = (state: State, props: Props) => props.idCliente ? props.idCliente : undefined;
    private tieneClienteProps = createSelectorRx(this.idClienteFromProps, idCliente => idCliente ? true : false);

    private filtrarDireccionesPermiso = (state: State, props: Props) => props.filtrarDireccionesPermiso;

    //NOTA: Le damos prioridad al NULL sobre el UNDEFINED, esto por que un NULL indica una limpieza por parte del usuario, en cambio un undefined indica que el valor no se conoce
    private idCliente = createSelectorRx(this.idClienteFromValue, this.idClienteFromProps, this.idClienteFromState, (val, props, state) => {
        var res = val === null ? props ? props : null : (props || state || val);

        return res;
    });

    direccionesCli = createSelectorRx(this.idCliente, id => id ? observeResource(resources.Cliente.ConsultarDirecciones, id) : Observable.from([[]]));


    private idSucursalUsuario = (state: State, props: Props) => props.idSucursalUsuario ? props.idSucursalUsuario : null;

    /**Id de la dirección del usuario, sólo se va a mostrar esta */
    private idDireccionUsuario = (state: State, props: Props) => props.idDireccionUsuario;

    private sucursal = createSelectorRx(this.idSucursalUsuario, id => {
        const ret = id != null ? observeResource(resources.Sucursal.getMemo, id) : null;
        return toObservable(ret);
    });

    private direcciones = createSelectorRx(
        this.direccionesCli,
        this.sucursal,
        this.filtrarDireccionesPermiso,
        this.idDireccionUsuario,
        (direcciones, suc, filtrar, idDirUsuario) => {
            if(idDirUsuario != null) {
                direcciones = direcciones.filter(x => x.IdRegistro == idDirUsuario);
            }

            if (filtrar) {
                if (suc != null) {
                    var municipios = (suc && suc.Municipios.map(x => x.IdMunicipio)) || [];
                    direcciones = direcciones.filter(x => municipios.indexOf(x.Direccion.IdMunicipio) != -1);
                } else {
                    direcciones = [];
                }
            }

            return direcciones;
        });

    private seleccionAutomatica = (state: State, props: Props) => props.seleccionAutomatica;

    private direccionesSelect = createSelectorRx(this.direcciones, this.idCliente, this.seleccionAutomatica, (direcciones, idCliente, seleccionAutomatica) => {
        if (direcciones && idCliente && direcciones.length == 1 && seleccionAutomatica)
            this.props.onChange(direcciones[0].IdRegistro);

        return direcciones.map<DireccionSelectorElement>(x => ({ id: x.IdRegistro, view: x.Direccion }));
    });

    private handleOnCliente = (idCliente: number) => {
        this.setState({ idCliente: idCliente });
        this.props.onChange(undefined);
    }

    private handleOnDireccion = async (idDireccion: number | null) => {
        //Establecer el ID
        this.props.onChange(idDireccion);
    }

    render() {
        const idClienteDireccion = this.idClienteDireccion(this.state, this.props);
        const idCliente = this.idCliente(this.state, this.props);
        const tieneClienteProps = this.tieneClienteProps(this.state, this.props);
        const direcciones = this.direccionesSelect(this.state, this.props);

        return (
            kea.autogrid(12, [
                <ClienteSelector value={idCliente} onChange={this.handleOnCliente as any} loading={this.props.loading} filtro={this.props.filtroCliente} readonly={tieneClienteProps || !!this.props.readonly} />,
                <DireccionSelector items={direcciones} value={idClienteDireccion} onChange={this.handleOnDireccion} loading={this.props.loading} idCliente={idCliente} readonly={this.props.readonly} />
            ])
        )
    }
}

export const DireccionClienteSelectorView = componentToRx<Props>(DireccionClienteSelectorViewNoRx, undefined, undefined, {
    loading: { loading: true }
});


// WEBPACK FOOTER //
// ./app/features/selectores/items/direccioncliente/direccionView.tsx